import {
  ADMIN_ONBOARDINGS_LOADED,
  ADMIN_ONBOARDINGS_CLEAR,
  ADMIN_ONBOARDING_DETAILS_LOADED,
  ADMIN_ONBOARDING_DETAILS_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  onboardings: null,
  details: null,
};

function adminOnboardings(state = initialState, action) {
  switch (action.type) {
    case ADMIN_ONBOARDINGS_LOADED:
      return { ...state, onboardings: action.payload.onboardings };
    case ADMIN_ONBOARDINGS_CLEAR:
      return { ...state, onboardings: null };
    case ADMIN_ONBOARDING_DETAILS_LOADED:
      return { ...state, details: action.payload.details };
    case ADMIN_ONBOARDING_DETAILS_CLEAR:
      return { ...state, details: null };
    default:
      return state;
  }
}

export default adminOnboardings;
